import { render, staticRenderFns } from "./MapPolygon.vue?vue&type=template&id=8148d74c&"
import script from "./MapPolygon.vue?vue&type=script&lang=js&"
export * from "./MapPolygon.vue?vue&type=script&lang=js&"
import style0 from "./MapPolygon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports